import { render, staticRenderFns } from "./AfterSaleAddress.vue?vue&type=template&id=81c2dbcc&scoped=true&"
import script from "./AfterSaleAddress.vue?vue&type=script&lang=js&"
export * from "./AfterSaleAddress.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleAddress.vue?vue&type=style&index=0&id=81c2dbcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c2dbcc",
  null
  
)

export default component.exports